/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */

import Vue from 'vue';
import '@sal/inview-plugin';
import Responsive from '@sal/layout';
import vueCustomElement from 'vue-custom-element';

Vue.use(vueCustomElement);

window.Vue = Vue;

Vue.use(Responsive);

const options = {
	props: ['contentType', 'edition', 'maasToken', 'securityId', 'securityType']
};

// Global Market Barometer
Vue.customElement(
	'sal-components-global-market-barometer',
	() => new Promise(resolve => {
		require(['./components/global-market-barometer.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// CEF Components
Vue.customElement(
	'sal-components-cef-analysis',
	() => new Promise(resolve => {
		require(['./components/cefs/analysis.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-chart',
	() => new Promise(resolve => {
		require(['./components/cefs/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-ownership',
	() => new Promise(resolve => {
		require(['./components/cefs/ownership.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-portfolio',
	() => new Promise(resolve => {
		require(['./components/cefs/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/cefs/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/cefs/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-quote-top',
	() => new Promise(resolve => {
		require(['./components/cefs/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-cef-risk',
	() => new Promise(resolve => {
		require(['./components/cefs/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// ETF Components
Vue.customElement(
	'sal-components-etf-analysis',
	() => new Promise(resolve => {
		require(['./components/etfs/analysis.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-chart',
	() => new Promise(resolve => {
		require(['./components/etfs/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-parent',
	() => new Promise(resolve => {
		require(['./components/etfs/parent.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-portfolio',
	() => new Promise(resolve => {
		require(['./components/etfs/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/etfs/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/etfs/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-quote-top',
	() => new Promise(resolve => {
		require(['./components/etfs/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-etf-risk',
	() => new Promise(resolve => {
		require(['./components/etfs/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// Fund Components
Vue.customElement(
	'sal-components-fund-analysis',
	() => new Promise(resolve => {
		require(['./components/funds/analysis.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-chart',
	() => new Promise(resolve => {
		require(['./components/funds/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/funds/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/funds/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-quote-top',
	() => new Promise(resolve => {
		require(['./components/funds/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-parent',
	() => new Promise(resolve => {
		require(['./components/funds/parent.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-portfolio',
	() => new Promise(resolve => {
		require(['./components/funds/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-fund-risk',
	() => new Promise(resolve => {
		require(['./components/funds/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// Index Components
Vue.customElement(
	'sal-components-index-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/indexes/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-index-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/indexes/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-index-quote-top',
	() => new Promise(resolve => {
		require(['./components/indexes/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// Pension Fund Components
Vue.customElement(
	'sal-components-pension-fund-chart',
	() => new Promise(resolve => {
		require(['./components/pension-funds/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-people',
	() => new Promise(resolve => {
		require(['./components/pension-funds/people.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-portfolio',
	() => new Promise(resolve => {
		require(['./components/pension-funds/portfolio.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/pension-funds/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/pension-funds/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-quote-top',
	() => new Promise(resolve => {
		require(['./components/pension-funds/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-pension-fund-risk',
	() => new Promise(resolve => {
		require(['./components/pension-funds/risk.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

// Stock Components
Vue.customElement(
	'sal-components-stock-chart',
	() => new Promise(resolve => {
		require(['./components/stocks/chart.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-dividends',
	() => new Promise(resolve => {
		require(['./components/stocks/dividends.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-financials',
	() => new Promise(resolve => {
		require(['./components/stocks/financials.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-key-metrics',
	() => new Promise(resolve => {
		require(['./components/stocks/key-metrics.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-ownership',
	() => new Promise(resolve => {
		require(['./components/stocks/ownership.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-quote-bottom',
	() => new Promise(resolve => {
		require(['./components/stocks/quote-bottom.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-quote-company-profile',
	() => new Promise(resolve => {
		require(['./components/stocks/quote-company-profile.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-quote-disclosure',
	() => new Promise(resolve => {
		require(['./components/stocks/quote-disclosure.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);

Vue.customElement(
	'sal-components-stock-quote-top',
	() => new Promise(resolve => {
		require(['./components/stocks/quote-top.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);


// Toolbox (Nav Buttons)
Vue.customElement(
	'sal-components-toolbox',
	() => new Promise(resolve => {
		require(['./components/sal-toolbox.vue'], lazyComponent => resolve(lazyComponent.default));
	}),
	options
);
